import React from "react";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { logout } from "../../modules/User/actions";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRupeeSign,
  faShoppingBag,
  faSignInAlt,
  faStore,
} from "@fortawesome/free-solid-svg-icons";

const TheHeaderDropdown = () => {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.auth.user.username);
  return (
    <CDropdown inNav className="c-header-nav-items mx-2" direction="down">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <div
          className="c-avatar"
          style={{ boxShadow: "0px 0px 10px #0000006e" }}
        >
          <CImg
            src={"./images/logo/loginlogo.png"}
            className="c-avatar-img"
            alt="USER PROFILE"
          />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem header tag="div" color="light" className="text-center">
          <strong style={{ textTransform: "capitalize" }}>{username}</strong>
        </CDropdownItem>

        <CDropdownItem onClick={() => dispatch(logout())}>
          {/* <CIcon name="cil-signout" className="mfe-2" /> */}
          <FontAwesomeIcon icon={faSignInAlt} />
          <span className="pl-2">Sign Out</span>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};

export default TheHeaderDropdown;
